import React__default, { useContext } from 'react';
import './index.js';
import Empty from '../empty/index.js';
import { ConfigContext } from './context.js';
const DefaultRenderEmpty = props => {
  const {
    componentName
  } = props;
  const {
    getPrefixCls
  } = useContext(ConfigContext);
  const prefix = getPrefixCls('empty');
  switch (componentName) {
    case 'Table':
    case 'List':
      return /*#__PURE__*/React__default.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE
      });
    case 'Select':
    case 'TreeSelect':
    case 'Cascader':
    case 'Transfer':
    case 'Mentions':
      return /*#__PURE__*/React__default.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        className: `${prefix}-small`
      });
    /* istanbul ignore next */
    default:
      // Should never hit if we take all the component into consider.
      return /*#__PURE__*/React__default.createElement(Empty, null);
  }
};
var DefaultRenderEmpty$1 = DefaultRenderEmpty;
export { DefaultRenderEmpty$1 as default };
//# sourceMappingURL=defaultRenderEmpty.js.map
